import countryMapping from '../constants/countryLanguageMap.ts';

// Home breadcrumb text translations by language
// Note: jp uses country code (not language code ja)
export const HOME_BREADCRUMB_TRANSLATIONS: Record<string, string> = {
  en: 'Home',
  fr: 'Accueil',
  de: 'Startseite',
  es: 'Inicio',
  pt: 'Início',
  jp: 'ホーム',
  ko: '홈',
  zh: '首页',
};

export const getLanguagesList = () => {
  const languageLists = process.env.GATSBY_LANGUAGE_CODENAMES?.split(',').filter(Boolean);
  return languageLists?.length ? languageLists : ['en'];
};
const regexLanguagePrefix = new RegExp(`^/(${getLanguagesList().join('|')})/`, 'gi');

export const getPathWithLanguage = (path: string, language: string) => {
  const languageToAppend = language === 'en' ? '' : `/${language}`;

  if (getLanguageFromPath(path) === language) {
    return path;
  }

  const pathWithoutLanguage = path.replace(regexLanguagePrefix, '/');

  return `${languageToAppend}${pathWithoutLanguage}`;
};
export const getLanguageFromPath = (pathname: string) =>
  getLanguagesList().find((lang) => pathname.startsWith(`/${lang}/`)) ?? 'en';

export const getAlternateLinks = (url: string, pathname: string) => {
  const languages = getLanguagesList();
  const alternateLinks = languages.map((lang) => ({
    hrefLang: countryMapping[lang] ?? lang,
    href: `${url}${getPathWithLanguage(pathname, lang)}`,
  }));

  // Add x-default for English
  if (languages.includes('en')) {
    alternateLinks.push({
      hrefLang: 'x-default',
      href: `${url}${getPathWithLanguage(pathname, 'en')}`,
    });
  }

  return alternateLinks;
};

export const isPageTranslated = ({
  preferredLanguage, // NOTE: The language set by the URL, i.e /en/ or /de/
  pageLanguage, // NOTE: The language of the page retrieved from the CMS
}: {
  preferredLanguage?: string;
  pageLanguage?: string;
}) => preferredLanguage === pageLanguage;
